import React from "react";
import Login from "./Login";

function CompanyLogin() {
  return <Login role="company employee" />;
}

export default CompanyLogin;
